import { Button, Form, Input, Modal } from "antd";
import { useMutation, useQueryClient } from "react-query";
import axios from "../../utils/axios";

export default function CancelModal({ visible, closeModal, id }) {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation({
    mutationKey: ["cancel_doc"],
    mutationFn: (formData) => axios.post("client/api/doc/cancel", formData, { showErrorMessage: true, showSuccessMessage: true }),
    onSuccess: ({ success }) => {
      if (success) {
        queryClient.refetchQueries({ queryKey: ["get_doc_list"] });
        queryClient.refetchQueries({ queryKey: ["get_user_doc_count"] });
        closeModal();
      }
    },
  });
  return (
    <Modal title="Document canceling confirmation" open={visible} onCancel={closeModal} footer={null} destroyOnClose>
      <Form form={form} onFinish={mutate} layout="vertical">
        <Form.Item name="docid" initialValue={id} hidden>
          <Input />
        </Form.Item>
        <Form.Item name="reason" label="Reason" rules={[{ required: true }]} required>
          <Input.TextArea placeholder="Type here why you are cancelling this document ... " />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" loading={isLoading} danger shape="round">
            Cancel this doc
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
